let Raven;

if (process.env.CLIENT) {
  Raven = require('raven-js').config(process.env.SENTRY_CLIENT_DSN, {
    environment: process.env.SENTRY_ENVIRONMENT,
    autoBreadcrumbs: {
      'xhr': true,
      'console': false,
      'dom': true,
      'location': true,
      'sentry': true
    }
  });
} else {
  Raven = require('raven').config(process.env.SENTRY_SERVER_DSN, {
    environment: process.env.SENTRY_ENVIRONMENT
  });
}

Raven.install();

const ravenMiddleware = store => next => action => {
  if (typeof action === 'object') {
    Raven.captureBreadcrumb({
      category: 'redux',
      message: action.type,
      data: action
    });
  }

  try {
    const dispatchResult = next(action);

    if (dispatchResult && typeof dispatchResult.catch === 'function') {
      dispatchResult.catch(err => {
        if (!err.__reportedInternally__ && ((err.meta && err.meta.method) && err.meta.method !== 'GET')) {
          Raven.captureException(err, {
            extra: {
              action: action,
              state: store.getState(),
              error: err
            }
          });

          err.__reportedInternally__ = true;
        }

        throw err;
      });
    }

    return dispatchResult;
  } catch (err) {
    Raven.captureException(err, {
      extra: {
        action: action,
        state: store.getState()
      }
    });

    throw err;
  }
};

export default ravenMiddleware;



// WEBPACK FOOTER //
// ./middlewares/raven.js